import React, { useEffect } from 'react'
import { CloseOutlined} from '@ant-design/icons';

import "./SideBarComponent.css"

interface Props{
    open: boolean
    setOpen:React.Dispatch<React.SetStateAction<boolean>>
    children?: React.ReactNode
}

const SideBarDeskComponent = ({open, setOpen, children}:Props) => {

  useEffect(() => {
    if (open) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    // Función de limpieza para remover la clase si el componente se desmonta
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [open]); // El efecto se ejecuta cada vez que isSidebarOpen cambia

  
  return (
    <>
    <div className='SideBardeskComponent-Component' style={{left:open ? "70vw" : "110vw"}}>
        <div className='SideBar-Header'>


            <div className='Sidebar-Header-logo'>
                <img src='/logo-small.png'  />
            </div>

            <div className='SideBar-Header-close'>
                <CloseOutlined onClick={()=>{setOpen(false)}} style={{cursor:"pointer", color:"#FFF"}} />
            </div>

        </div>
        <div className='SideBar-content'>
        {children}
        </div>
    </div>
    
    <div className='SideBarDeskComponent-Background' onClick={()=>{setOpen(false)}} style={{display:open ? "flex" : "none"}}>

    </div>
    </>

  )
}

export default SideBarDeskComponent